export const account_type = [
  {
    id: "1",
    Type: "Savings account",
    Created_Date: "24 Dec 2024",
    Status: "Active",
  },
  {
    id: "2",
    Type: "Current Account",
    Created_Date: "10 Dec 2024",
    Status: "Inactive",
  },
  {
    id: "3",
    Type: "Salary Account",
    Created_Date: "27 Nov 2024",
    Status: "Active",
  },
];
